import { useSyncExternalStore } from "react";

/* ══════════════════════════════════════════════════════════════════
   Ob das Nachschlagen offen ist — ein Schalter für die ganze Anwendung.

   Luca, 17.09.2026: *„Ich verstehe jetzt mittlerweile nicht mehr, wozu
   ich dann noch Preisauskunft und Verfügbarkeits-Check brauche. Warum
   kann ich das nicht genau so gut dann auch in der Direktvermietung
   machen und das jetzt merken?"*

   Übrig bleibt **ein** Fall: der Blick aus einer fremden Maske heraus,
   ohne sie zu verlassen. Wer in der Kundenakte sitzt und am Telefon
   gefragt wird, was der Bagger nächste Woche kostet, darf die Akte
   nicht verlieren — dafür ist das Deckblatt gebaut.

   **Warum ein Schalter neben React und kein Kontext.** Das Blatt hängt
   in der Schale (`schale/Schale.tsx`), aufgemacht wird es von der
   Seitenleiste und vom Tastenkürzel — und beide liegen in anderen
   Zweigen des Baums. Ein Kontext müsste die ganze Anwendung umschließen,
   damit zwei Knöpfe miteinander reden; `useSyncExternalStore` ist dafür
   der Weg, den React selbst vorsieht. Dieselbe Bauform wie bei der
   Merkliste (`daten/merkliste.ts`), aus demselben Grund.

   **Kein `localStorage`.** Ein Blatt ist keine Ablage: Wer die
   Anwendung morgen öffnet, soll seine Maske sehen und kein Blatt
   darüber, das er gestern aufgemacht hat.
   ══════════════════════════════════════════════════════════════════ */

let offen = false;
const hoerer = new Set<() => void>();

function melden(): void {
  hoerer.forEach((ruf) => ruf());
}

export function nachschlagenOeffnen(): void {
  if (offen) return;
  offen = true;
  melden();
}

export function nachschlagenSchliessen(): void {
  if (!offen) return;
  offen = false;
  melden();
}

export function nachschlagenUmschalten(): void {
  offen = !offen;
  melden();
}

function anmelden(ruf: () => void): () => void {
  hoerer.add(ruf);
  return () => { hoerer.delete(ruf); };
}

const jetzt = () => offen;
/** Auf dem Server ist nichts offen — und diese Anwendung läuft ohnehin im Browser. */
const nie = () => false;

export function useNachschlagenOffen(): boolean {
  return useSyncExternalStore(anmelden, jetzt, nie);
}
